// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React from "react";
import { View, Text } from "react-native";
import translations from "../config/translation.json";
import fonts from "../config/fonts";
import AsyncStorage from "@react-native-async-storage/async-storage";

let preferredLanguage = "DE";
let cachedTranslations = {};

const initializeTranslations = async () => {
    try {
        const storedLanguage = await AsyncStorage.getItem("preferredLanguage");
        preferredLanguage = storedLanguage || "DE";

        // Populate cache
        const translationsForLanguage = {};
        Object.keys(translations).forEach((key) => {
            translationsForLanguage[key] =
                translations[key]?.[preferredLanguage] || key;
        });
        cachedTranslations = translationsForLanguage;
    } catch (error) {
        console.error("Error initializing translations:", error);
    }
};

export const updateLanguage = async (language) => {
    try {
        await AsyncStorage.setItem("preferredLanguage", language);
        preferredLanguage = language;

        location.reload(true);

        // Update cache
        const translationsForLanguage = {};
        Object.keys(translations).forEach((key) => {
            translationsForLanguage[key] = translations[key]?.[language] || key;
        });

        cachedTranslations = translationsForLanguage;
    } catch (error) {
        console.error("Error updating language:", error);
    }
};

export const getTranslation = (key) => {
    return cachedTranslations[key] || key;
};

initializeTranslations();

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) {
        //console.error("Data non valida:", dateString);
        return dateString;
    }

    const res = date.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });

    return res;
};
